var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3305 3.71895C10.5318 3.97052 10.491 4.33761 10.2394 4.53886C9.57023 5.07423 8.8886 5.97855 8.29229 6.93755C7.70315 7.88504 7.22772 8.83573 6.96051 9.41875C6.87032 9.61552 6.6786 9.74617 6.46248 9.75814C6.24636 9.77011 6.04138 9.66143 5.93002 9.47582C5.73865 9.15688 5.38681 8.73189 4.99743 8.32426C4.60942 7.91806 4.22484 7.57143 3.99027 7.40084C3.72973 7.21135 3.67212 6.84652 3.86161 6.58598C4.0511 6.32543 4.41593 6.26782 4.67647 6.45731C4.99109 6.68612 5.43027 7.08836 5.84106 7.51841C6.00436 7.68936 6.16966 7.87146 6.32575 8.05589C6.59152 7.53554 6.92373 6.92912 7.30154 6.3215C7.91592 5.33343 8.6821 4.29067 9.51064 3.62785C9.76221 3.42659 10.1293 3.46738 10.3305 3.71895Z",
    fill: "#118462"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckGreen);
export default __webpack_public_path__ + "static/media/ic-check-green.b37eeaee17f8c1fbac94645c4ce57b89.svg";
export { ForwardRef as ReactComponent };